exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".unit-unselectable-20RPz{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.unit-para-panel-item-unit-2SX5T{display:inline-block;margin-left:2px}", ""]);

// Exports
exports.locals = {
	"unselectable": "unit-unselectable-20RPz",
	"para-panel-item-unit": "unit-para-panel-item-unit-2SX5T"
};